const togglePanels = ({
                        toggleButtonSelector = `.js-toggle-btn`,
                        toggleContainerSelector = `.js-toggle-block`,
                        toggleClass = `is-open`,
                      }) => {
  const toggleButton = document.querySelector(toggleButtonSelector);
  const toggleContainer = document.querySelector(toggleContainerSelector);

  if (toggleButton && toggleContainer) {
    function showPanelHandler() {
      toggleContainer.classList.add(toggleClass);
      toggleButton.removeEventListener(`click`, showPanelHandler);
      toggleButton.addEventListener(`click`, hidePanelHandler);

      setTimeout(() => {
        document.body.addEventListener(`click`, onLayoutClick);
      }, 200);
    }

    function hidePanelHandler() {
      toggleContainer.classList.remove(toggleClass);
      toggleButton.removeEventListener(`click`, hidePanelHandler);
      toggleButton.addEventListener(`click`, showPanelHandler);
      document.body.removeEventListener(`click`, onLayoutClick);
    }

    function onLayoutClick(event) {
      const target = event.target;

      if (!target.classList.contains(toggleClass) && !target.closest(`.${toggleClass}`)) {
        hidePanelHandler();
      }
    }

    toggleButton.addEventListener(`click`, showPanelHandler);
  }
};

export default togglePanels;
